import Vue from 'vue';
import Component from 'vue-class-component';
import { CombinedVueInstance } from 'vue/types/vue';
import TombolaModal from '@components/tombola-modal/tombola-modal.vue';
import { UserPreferences } from '@/app-modules/store/modules/user-preferences';
import { UserSettingsUpdatedEventName } from '@/components/user-settings/_domain/models/events';

@Component({
  name: 'App'
})
export default class App extends Vue {
  private backgroundColour: string = this.$tombolaStore.Get(UserPreferences).backgroundColour;

  private async mounted() {
    this.$eventbus.$on(UserSettingsUpdatedEventName, this.updateBackgroundColour);
  }

  private beforeDestroy() {
    this.$eventbus.$off(UserSettingsUpdatedEventName, this.updateBackgroundColour);
  }

  private updateBackgroundColour() {
    Vue.nextTick(() => {
      this.backgroundColour = this.$tombolaStore.Get(UserPreferences).backgroundColour;
    });
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/components/app/app.component.ts